module.exports = __webpack_public_path__ + "img/tabler-icon-cash.c2140233.svg";